import result from 'lodash-es/result';

export class ArrayHelper {
    public static sort(arrayToSort: any[], comparisonPath: string): any[] {
        if (!arrayToSort) {
            return arrayToSort;
        }

        return arrayToSort.sort((item1: any, item2: any) => {
            const compare1: any = result(item1, comparisonPath);
            const compare2: any = result(item2, comparisonPath);

            if (compare1 > compare2) {
                return 1;
            } if (compare1 < compare2) {
                return -1;
            }

            return 0;
        });
    }

    /**
     * Split a large array into smaller chunks
     */
    public static createChunks(array: any[], chunkSize: number): any[] {
        const chunks: any = [];

        for (let i: number = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }

        return chunks;
    }
}
